/*
  Product form behaviour for the store's custom sections
  (PDP Main Product, Custom Featured Product).

  Handles:
  - quantity +/- buttons (.js-qty__wrapper)
  - variant option pickers (dropdowns or buttons) -> hidden variant id
  - AJAX add to cart, then opens the cart drawer (or goes to /cart)
*/
(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty__adjust');
    if (!btn) return;
    var wrap = btn.closest('.js-qty__wrapper');
    var input = wrap && wrap.querySelector('.js-qty__num');
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var val = parseInt(input.value, 10) || min;
    val = btn.classList.contains('js-qty__adjust--plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant pickers ---------- */
  function initForm(form) {
    var sid = form.getAttribute('data-store-product-form');
    var variantsEl = document.getElementById('VariantsJson-' + sid);
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.value || variantsEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[name="add"]');
    var buttonText = document.getElementById('AddToCartText-' + sid);

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('.variant-input-wrap').forEach(function (wrap) {
        var index = parseInt((wrap.getAttribute('data-index') || 'option1').replace('option', ''), 10) - 1;
        var select = wrap.querySelector('select');
        var checked = wrap.querySelector('input[type="radio"]:checked');
        opts[index] = select ? select.value : (checked ? checked.value : null);
      });
      return opts;
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
      });
      if (!variant) return;

      // make sure the hidden select can carry this id (sold-out options have no value)
      if (idInput.tagName === 'SELECT' && !idInput.querySelector('option[value="' + variant.id + '"]')) {
        var opt = document.createElement('option');
        opt.value = variant.id;
        opt.textContent = variant.title;
        idInput.appendChild(opt);
      }
      idInput.value = variant.id;

      if (button) {
        button.disabled = !variant.available;
        if (buttonText) {
          buttonText.textContent = variant.available
            ? buttonText.getAttribute('data-default-text')
            : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        }
      }

      var label = form.querySelector('.variant__label-info span');
      if (label && variant.option1) label.textContent = variant.option1;

      var root = form.closest('[data-section-id]') || document;
      root.querySelectorAll('[data-store-price]').forEach(function (el) { el.textContent = money(variant.price); });

      if (window.history && history.replaceState && root.id === 'main_sec_pd' && /\/products\//.test(location.pathname)) {
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('.variant-input-wrap')) onChange();
    });
  }

  /* ---------- Add to cart ---------- */
  function showError(form, message) {
    var box = form.querySelector('.store-form-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'store-form-error';
      box.setAttribute('role', 'alert');
      var btn = form.querySelector('[name="add"]');
      (btn && btn.parentNode ? btn.parentNode : form).appendChild(box);
    }
    box.textContent = message;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-store-product-form]');
    if (!form || e.defaultPrevented) return;
    e.preventDefault();

    var button = form.querySelector('[name="add"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var data = new FormData(form);
    if (!data.get('selling_plan')) data.delete('selling_plan');
    if (cart && cart.getSectionsToRender) {
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      data.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); }
    var old = form.querySelector('.store-form-error');
    if (old) old.textContent = '';

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          showError(form, response.description || response.message || 'Could not add to cart');
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'store-product-form', productVariantId: data.get('id'), cartData: response });
        }
        if (cart && cart.renderContents && response.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { showError(form, 'Could not add to cart. Please try again.'); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('loading'); }
      });
  });

  /* ---------- Hide bottom sticky bars while the cart drawer is open ----------
     Only does work when the drawer opens or closes (no polling). */
  var stickyWatcherReady = false;
  function setupStickyBarToggle() {
    if (stickyWatcherReady) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    stickyWatcherReady = true;
    var hidden = [];

    function hideBars() {
      if (hidden.length) return;
      document.querySelectorAll('body *').forEach(function (el) {
        if (drawer.contains(el) || el.closest('header, .shopify-section-group-header-group')) return;
        var s = window.getComputedStyle(el);
        var bottom = parseInt(s.bottom, 10);
        if ((s.position === 'fixed' || s.position === 'sticky') && !isNaN(bottom) && bottom <= 20 && s.display !== 'none') {
          el.style.display = 'none';
          hidden.push(el);
        }
      });
    }
    function showBars() {
      hidden.forEach(function (el) { el.style.display = ''; });
      hidden = [];
    }
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) hideBars(); else showBars();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }


  /* ---------- Close (X) button inside the menu drawer ---------- */
  function setupMenuClose() {
    document.querySelectorAll('header-drawer details').forEach(function (details) {
      var drawer = details.querySelector('.menu-drawer');
      if (!drawer || drawer.querySelector('.store-menu-close')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'store-menu-close';
      btn.setAttribute('aria-label', 'Close menu');
      btn.innerHTML = '<svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var summary = details.querySelector('summary');
        if (summary) summary.click();
      });
      drawer.appendChild(btn);
    });
  }


  /* ---------- Hide $0 products in the "Customers who bought this also bought" app block ---------- */
  var ZERO_PRICE = /^\s*(?:[$\u20ac\u00a3\u20b1]|USD|PHP)?\s?0(?:[.,]00)?\s?(?:USD|PHP|EUR|GBP)?\s*$/i;
  var REC_TITLE = /customers who bought this also bought/i;

  function hasImg(el) { return !!(el && el.querySelector && el.querySelector('img')); }

  function hideZeroPriceRecs() {
    var titles = [];
    document.querySelectorAll('h1,h2,h3,h4,h5,p,div,span').forEach(function (el) {
      if (el.childElementCount === 0 && REC_TITLE.test(el.textContent || '')) titles.push(el);
    });
    titles.forEach(function (title) {
      // the block = first ancestor that holds several product images
      var box = title.parentElement;
      while (box && box !== document.body && box.querySelectorAll('img').length < 2) box = box.parentElement;
      if (!box || box === document.body) return;
      box.querySelectorAll('*').forEach(function (el) {
        if (el.childElementCount !== 0 || !ZERO_PRICE.test(el.textContent || '')) return;
        // walk up to the product card (a child of the list that holds the cards)
        var card = el;
        while (card.parentElement && card.parentElement !== box) {
          var siblingsWithImg = Array.prototype.filter.call(card.parentElement.children, hasImg).length;
          if (hasImg(card) && siblingsWithImg >= 2) break;
          card = card.parentElement;
        }
        if (card && card !== box) card.style.display = 'none';
      });
    });
  }

  function watchRecs() {
    hideZeroPriceRecs();
    // the app loads its products after the page; re-check for a short while, throttled
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; hideZeroPriceRecs(); }, 300);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); hideZeroPriceRecs(); }, 20000);
  }

  function init() {
    document.querySelectorAll('form[data-store-product-form]').forEach(initForm);
    setupStickyBarToggle();
    setupMenuClose();
    watchRecs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();